<template>
  <div class="benefits-switcher-wrap">
    <div class="container">
      <div class="flex-grid">
        <div class="module">
          <div class="benefits-selector selector-1 mt-2">
            <div class="dropdown">
              <button id="dropdown-1-btn" class="dropdown-toggle d-flex justify-content-between align-items-center w-100" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span>{{ selectedMbvLevel.name }}</span>
                <img src="/images/icon_caret-down.png" class="arrow" alt="">
              </button>
              <div class="dropdown-menu w-100" aria-labelledby="dropdown-1-btn">
                <div class="d-flex flex-column align-items-start">
                  <button v-for="(level, index) in content.mbv_levels" :key="index" :class="`option ${level.code} w-100`" ref="mbvLevelEl" @click="selectMbvLevel(index,$event)" @keydown.enter="selectMbvLevel(index, $event)" v-html="level.name"></button>
                </div>
              </div>
            </div>
            <div class="benefits">
              <div class="wrap">
                  <template v-if="mbvLevelIsSelected">
                    <h2 class="subheading benefits-heading">{{ flyOnPoints }} <span v-html="content.landing.sec_1.fly_on_points"></span></h2>
                    <p v-html="content.towards_higher_status"></p>
                    <a :href="content.landing.sec_1.learn_more_href" class="link-4" target="_blank">{{ content.landing.sec_1.learn_more }}</a>
                  </template>
                  <p v-else class="fz-2xs mb-0">{{ content.reveal_your_results }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="module">
          <div class="wrap d-md-none">
            <h2 class="subheading" v-html="content.landing.sec_1.jal_lead_in.heading"></h2>
            <p class="body" v-html="content.landing.sec_1.jal_lead_in.body"></p>
            <p class="fz-2xs" v-html="content.landing.sec_1.jal_lead_in.instructions"></p>
          </div>
            <div class="benefits-selector selector-2 mt-2">
              <div class="dropdown">
                <button id="dropdown-2-btn" class="dropdown-toggle d-flex justify-content-between align-items-center w-100" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span>{{ selectedJalLevel.name }}</span>
                  <img src="/images/icon_caret-down.png" class="arrow" alt="">
                </button>
                <div class="dropdown-menu w-100" aria-labelledby="dropdown-1-btn">
                  <div class="d-flex flex-column align-items-start">
                    <button v-for="(level, index) in content.jal_levels" :key="index" :class="`option ${level.code} w-100`" ref="jalLevelEl" @click="selectJalLevel(index, $event)" @keydown.enter="selectJalLevel(index, $event)" v-html="level.name"></button>
                  </div>
                </div>
              </div>
              <div class="benefits">
                <div v-if="jalLevelIsSelected" v-for="(section, index) in content.benefits[levelsKey]" :key="index" class="section">
                  <h2 v-if="section.heading" class="subheading benefits-heading" v-html="replaceWithJalLevel(section.heading)"></h2>

                  <p v-if="section.body" class="benefit-body" v-html="replaceWithJalLevel(section.body)"></p>

                  <h3 v-if="section.list_heading" class="list-heading" v-html="section.list_heading"></h3>

                  <div v-if="section.list" class="benefits-list-wrap d-flex justify-content-center">
                    <ul class="benefit-list">
                      <li v-for="(li, index) in section.list" :key="index" v-html="li"></li>
                    </ul>
                  </div>

                  <a v-if="section.link" :href="section.link" class="link-4 benefits-link" target="_blank">{{ content.view_all_benefits }}</a>
                </div>
                <p v-else class="text-center fz-2xs">{{ content.reveal_your_results }}</p>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const content = APP_japan_airlines_content;
const selectedMbvLevel = ref([]);
const selectedJalLevel = ref([]);
const mbvLevelIsSelected = ref(false);
const jalLevelIsSelected = ref(false);
const mbvLevelEl = ref(null);
const jalLevelEl = ref(null);

const levelsKey = computed(() => `${selectedMbvLevel.value.code}_${selectedJalLevel.value.code}`);

const flyOnPoints = computed(() => {
  switch (selectedMbvLevel.value.code) {
    case 'member':
      return '2,000';
      break;
    case 'silver':
      return '5,000';
      break;
    case 'lifetime_silver':
      return '5,000';
      break;
    case 'gold':
      return '10,000';
      break;
    case 'lifetime_gold':
      return '10,000';
      break;
    case 'platinum':
      return '20,000';
      break;
    case 'lifetime_platinum':
      return '20,000';
      break;
    case 'titanium':
      return '30,000';
      break;
    case 'lifetime_titanium':
      return '30,000';
      break;
    case 'ambassador':
      return '40,000';
      break;
    default:
      return '';
  }
});

function replaceWithJalLevel(string) {
  let copy = string;
  if (string.includes(':partner_level_name')) {
    copy = string.replace(':partner_level_name', selectedJalLevel.value.name)
  }
  return copy;
}

function selectMbvLevel(i, e) {
  mbvLevelEl.value.forEach((el) => {
    el.classList.remove('d-none');
  });
  selectedMbvLevel.value = content.mbv_levels[i];
  e.target.classList.add('d-none');
  q('.option.mbv_status').classList.add('d-none');
  mbvLevelIsSelected.value = true;

  console.log(levelsKey.value);
}

function selectJalLevel(i, e) {
  jalLevelEl.value.forEach((el) => {
    el.classList.remove('d-none');
  });
  selectedJalLevel.value = content.jal_levels[i];
  e.target.classList.add('d-none');
  q('.option.jal_status').classList.add('d-none');
  jalLevelIsSelected.value = true;

  console.log(levelsKey.value);
}


onMounted(() => {
  selectedMbvLevel.value = content.mbv_levels[0];
  selectedJalLevel.value = content.jal_levels[0];

  mbvLevelEl.value[0].classList.add('d-none');
  jalLevelEl.value[0].classList.add('d-none');
});
</script>
